module.exports = __webpack_public_path__ + "static/media/btn_nebel.297bd80a.png";